import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { aiPodService, type AiPod } from '../../../services/aiPodService';
import { Page, PageHeader, Section } from '../../../components/layout/primitives';
import { Button } from '../../../components/ui/Button';
import ChatbotTemplateEditor from './components/ChatbotTemplateEditor';

/** "Configure" for a chat-only pod: the chatbot each subscriber gets. */
const AiPodChatConfigure: React.FC = () => {
  const { aiPodId } = useParams<{ aiPodId: string }>();
  const navigate = useNavigate();
  const [pod, setPod] = useState<AiPod | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!aiPodId) return;
    aiPodService
      .getAiPodById(aiPodId)
      .then(setPod)
      .catch((e: any) => setError(e?.message ?? 'AI Pod not found'));
  }, [aiPodId]);

  return (
    <Page>
      <PageHeader
        title={
          <div className="flex items-center gap-3">
            <Button tone="muted-text" onClick={() => navigate('/super-ai-pod')}>
              <ArrowLeftIcon className="h-5 w-5" />
            </Button>
            {pod ? `${pod.name} — chat` : 'Configure chat'}
          </div>
        }
        subtitle="Chat-only pod"
      />
      <Section className="pt-0">
        {error ? (
          <p className="text-sm text-red-600">{error}</p>
        ) : !pod ? (
          <p className="text-sm text-agentic-text-muted">Loading…</p>
        ) : (
          <div className="rounded-panel bg-white p-6 shadow-card">
            <ChatbotTemplateEditor pod={pod} onSaved={setPod} />
          </div>
        )}
      </Section>
    </Page>
  );
};

export default AiPodChatConfigure;
